import { Observable, of } from "rxjs";
import { MODAL_MIN_WIDTH } from "src/app/shared/helpers/constants";
import { CustomTranslationService } from "src/app/shared/translation/custom-translation.service";
import { ModalDialogService } from "src/app/shared/ui-elements/modal-dialog/modal-dialog.service";

interface InputConfig {
  isVisible: boolean;
  isRequired: boolean;
  isDisable: boolean;
}
interface AddressConfiguration {
  firstName?: InputConfig;
  lastName?: InputConfig;
  firmName?: InputConfig;
  addressSalutation?: InputConfig;
  title?: InputConfig;
  letterSalutation?: InputConfig;
  country?: InputConfig;
  language?: InputConfig;
  postCode?: InputConfig;
  city?: InputConfig;
  street?: InputConfig;
  houseNumber?: InputConfig;
  state?: InputConfig;
  county?: InputConfig;
  privatePhone?: InputConfig;
  cellPhone?: InputConfig;
  cellPhone2?: InputConfig;
  businessPhone?: InputConfig;
  eMail?: InputConfig;
  web?: InputConfig;
  showSalutationsTitleSwitch?: boolean;
  showStatesCantonSwitch?: boolean;
  showPhonesSwitch?: boolean;
  showWebSwitch?: boolean;
  isSalutationTitleEnabled?: boolean;
  isStateCantonEnabled?: boolean;
  isPhoneEnabled?: boolean;
  isWebEnabled?: boolean;
}
export class AddressFormConfiguration implements AddressConfiguration {
  firstName: InputConfig;
  lastName: InputConfig;
  firmName: InputConfig;
  addressSalutation: InputConfig;
  title: InputConfig;
  letterSalutation: InputConfig;
  country: InputConfig;
  language: InputConfig;
  postCode: InputConfig;
  city: InputConfig;
  street: InputConfig;
  houseNumber: InputConfig;
  state: InputConfig;
  county: InputConfig;
  privatePhone: InputConfig;
  cellPhone: InputConfig;
  cellPhone2: InputConfig;
  businessPhone: InputConfig;
  eMail: InputConfig;
  web: InputConfig;

  showSalutationsTitleSwitch: boolean;
  showStatesCantonSwitch: boolean;
  showPhonesSwitch: boolean;
  showWebSwitch: boolean;

  isSalutationTitleEnabled?: boolean;
  isStateCantonEnabled?: boolean;
  isPhoneEnabled?: boolean;
  isWebEnabled?: boolean;

  constructor(config: AddressConfiguration = {}, private translateSrv?: CustomTranslationService, private dialogService?: ModalDialogService) {
    this.firstName = config.firstName ?? { isVisible: true, isRequired: true, isDisable: false };
    this.lastName = config.lastName ?? { isVisible: true, isRequired: true, isDisable: false };
    this.firmName = config.firmName ?? { isVisible: true, isRequired: true, isDisable: false };
    this.addressSalutation = config.addressSalutation ?? { isVisible: true, isRequired: false, isDisable: false };
    this.title = config.title ?? { isVisible: true, isRequired: false, isDisable: false };
    this.letterSalutation = config.letterSalutation ?? { isVisible: true, isRequired: false, isDisable: false };
    this.country = config.country ?? { isVisible: true, isRequired: true, isDisable: false };
    this.language = config.language ?? { isVisible: true, isRequired: true, isDisable: false };
    this.postCode = config.postCode ?? { isVisible: true, isRequired: true, isDisable: false };
    this.city = config.city ?? { isVisible: true, isRequired: true, isDisable: false };
    this.street = config.street ?? { isVisible: true, isRequired: true, isDisable: false };
    this.houseNumber = config.houseNumber ?? { isVisible: true, isRequired: false, isDisable: false };
    this.state = config.state ?? { isVisible: true, isRequired: true, isDisable: false };
    this.county = config.county ?? { isVisible: true, isRequired: true, isDisable: false };
    this.privatePhone = config.privatePhone ?? { isVisible: true, isRequired: false, isDisable: false };
    this.cellPhone = config.cellPhone ?? { isVisible: true, isRequired: false, isDisable: false };
    this.cellPhone2 = config.cellPhone2 ?? { isVisible: false, isRequired: false, isDisable: false };
    this.businessPhone = config.businessPhone ?? { isVisible: true, isRequired: false, isDisable: false };
    this.eMail = config.eMail ?? { isVisible: true, isRequired: false, isDisable: false };
    this.web = config.web ?? { isVisible: true, isRequired: false, isDisable: false };

    this.showSalutationsTitleSwitch = config.showSalutationsTitleSwitch ?? true;
    this.showStatesCantonSwitch = config.showStatesCantonSwitch ?? true;
    this.showPhonesSwitch = config.showPhonesSwitch ?? true;
    this.showWebSwitch = config.showWebSwitch ?? true;
    this.isSalutationTitleEnabled = config.isSalutationTitleEnabled ?? true;
    this.isStateCantonEnabled = config.isStateCantonEnabled ?? true;
    this.isPhoneEnabled = config.isPhoneEnabled ?? true;
    this.isWebEnabled = config.isWebEnabled ?? true;
  }

  public isAddressValidConfirmationModal(isCityAddressValid: boolean): Observable<boolean> {
    if (!isCityAddressValid && this.translateSrv && this.dialogService) {
      const title = this.translateSrv.instant('addNewCustomer.address.modal.confirmation.title');
      const message = this.translateSrv.instant('addNewCustomer.address.modal.confirmation.message');
      this.dialogService.open({
        title: title,
        cancelTextBtn: 'general.label.no',
        confirmTextBtn: 'general.label.yes',
        textContent: message,
        confirmBtnClass: 'button-primary',
        cancelBtnClass: 'button-empty button-left-aligned ',
      },
        { minWidth: MODAL_MIN_WIDTH, autoFocus: false }
      );
      return this.dialogService.confirmed()
    }
    return of(true)
  }

  public disableForm(): void {
    this.firstName.isDisable = true;
    this.lastName.isDisable = true;
    this.firmName.isDisable = true;
    this.addressSalutation.isDisable = true;
    this.title.isDisable = true;
    this.letterSalutation.isDisable = true;
    this.country.isDisable = true;
    this.language.isDisable = true;
    this.postCode.isDisable = true;
    this.city.isDisable = true;
    this.street.isDisable = true;
    this.houseNumber.isDisable = true;
    this.state.isDisable = true;
    this.county.isDisable = true;
    this.privatePhone.isDisable = true;
    this.cellPhone.isDisable = true;
    this.cellPhone2.isDisable = true;
    this.businessPhone.isDisable = true;
    this.eMail.isDisable = true;
    this.web.isDisable = true;
  }
}
